import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CompletitionStatus, LinearProgressCustom } from "../../components/CarouselCardRestyle/CarouselCard.style";

type IProgressBar = {
    progression: string,
    maxWidth: string,
}

export const ProgressBar = ({
  progression,
  maxWidth
}: IProgressBar)=> {
  const theme = useTheme();
  const { t } = useTranslation();
  function handleProgressionValue() {
    if (progression && progression !== "0%") {
      return Number(progression.replace("%", ""));
    }
    return 1;
  }

  return (
    <Stack
      direction={ "column" }
      maxWidth={ maxWidth }
      marginBottom="0.5rem"
      id="progressbar-container"
      data-testid="progressbar-container"
    >
      <LinearProgressCustom
        id="progressbar-bar"
        data-testid="progressbar-bar"
        aria-label={ t("activity_progress") }
        aria-valuenow={ handleProgressionValue() }
        aria-valuemin={ 0 }
        aria-valuemax={ 100 }
        variant="determinate"
        value={ handleProgressionValue() }
        $isCompleted={ progression === "100%" }
      />
      <CompletitionStatus id={ "completion-status" } data-testid="progressbar-completion-status">
        <Box
          sx={ {
            height: "1.44rem",
            display: "flex",
            alignItems: "center"
          } }
        >
          <Typography
            color={ theme.customColors.textPrimary }
            fontSize={ "0.75rem" }
          >
            { t("completion") }
          </Typography>
        </Box>

        <Typography
          data-testid="progressbar-percentage"
          color={ theme.customColors.textPrimary }
          fontSize={ "0.75rem" }
        >
          { progression ?? "0%" }
        </Typography>
      </CompletitionStatus>
    </Stack>
  );
};
